// useModuleGate.js
import { useAuth } from "../contexts/AuthContext";

export const useModuleGate = () => {
  const { canAccessModuleFeature } = useAuth();

  const hasAny = (codes = []) =>
    !codes.length || codes.some((code) => canAccessModuleFeature(code));

  return { hasAny };
};
